import { useaxios } from "../../../utils/useaxios";
export default (expense_type_id, expense_type_state) => recaller => setrecaller => initDispatch => clear => {
    var today = new Date();
    today = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    initDispatch({ type: 'loadingTrue' });
    useaxios('expense_type/changestate.php', { expense_type_id, expense_type_state }).then((res) => {
        if (res == "Unauthorized") {
            clear();
            return;
        } else if (res == "request_failed") {
            alert('no internet connection');
            initDispatch({ type: 'loadingFalse' });
            return false;
        } else if (res.status == "ok") {
            setrecaller(recaller + 1);
        }
        // setloading(false);
    });
}